import classnames from 'classnames';

export type LoadingDotsColor = 'black' | 'white' | 'gray' | 'gradient';

interface LoadingDotsProps {
  color?: LoadingDotsColor;
  transparent?: boolean;
  dotSize?: 'x-small' | 'small' | 'large';
}

const LoadingDots: React.FC<LoadingDotsProps> = ({ color = 'white', dotSize = 'large' }) => {
  const dotsContainerClasses = classnames('flex justify-center');

  const gradientSpanClasses = 'bg-gradient-full bg-[length:300%_100%]';

  const dotClasses = classnames('mx-[2px] animate-bounce rounded-full', {
    'my-[9px] size-[7px]': dotSize === 'large',
    'my-[10px] size-1': dotSize === 'small',
    'my-[12px] size-0.5': dotSize === 'x-small',
    'bg-white': color === 'white',
    'bg-gray-darker': color === 'black',
    'bg-gray-medium': color === 'gray',
    [gradientSpanClasses]: color === 'gradient'
  });

  const firstDotClasses = classnames(dotClasses, {
    'bg-dot': color === 'white',
    'bg-[position:0%_0%]': color === 'gradient'
  });
  const secondDotClasses = classnames(dotClasses, {
    'bg-dot-dark': color === 'white',
    'bg-center': color === 'gradient'
  });
  const thirdDotClasses = classnames(dotClasses, {
    'bg-dot-darker': color === 'white',
    'bg-[position:100%_0%]': color === 'gradient'
  });

  return (
    <span role="presentation" className={dotsContainerClasses}>
      <span className={firstDotClasses}></span>
      <span style={{ animationDelay: '200ms' }} className={secondDotClasses}></span>
      <span style={{ animationDelay: '400ms' }} className={thirdDotClasses}></span>
    </span>
  );
};

export default LoadingDots;
